<template>
  <div class="blog-tags">
      <tag-icon width="25" fill="currentColor" class="text-grey" />
      <div class="blog-tag" v-for='(item, k) in items' :key="k">{{ item }}</div>
  </div>
</template>

<script>

import TagIcon from "@/components/Svg/TagIcon";

export default {
    components: { TagIcon },
    props: ['items']
}
</script>

<style>

</style>
